import { Td, Tr } from './styles';

interface IMaterialItem {
  materialDesc: string;
  diteCodigo: string;
  quantidade: number;
}

export default function MaterialItem({
  diteCodigo,
  quantidade,
  materialDesc,
}: IMaterialItem): JSX.Element {
  return (
    <Tr>
      <Td>{diteCodigo}</Td>
      <Td>{materialDesc}</Td>
      <Td>{quantidade}</Td>
    </Tr>
  );
}
